
import React from "react";

const PanelWrapperNoHeader = ({ title, help_text, children }) =>
{
    return (
        <div>
            <div className="panel-body panel-body-adulthood">
                {children}
            </div>
        </div>
    )
}
export default PanelWrapperNoHeader;